export const juniorsCourses = {
  Basics: [
    {
      id: 'code-juniors-courses/introduction-to-computers-and-programming',
      title: 'Introduction to Computers & Programming',
      img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/White/IntroductionIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/introduction-to-computers-and-programming.png',
      desc: 'Begin your journey into computing basics',
      courseLevel: 'Beginner',
      cardBgColor: '#f8edfb',
    },
    {
      id: 'code-juniors-courses/logical-thinking-and-flowchart-design',
      title: 'Logical Thinking & Flowchart Design',
      img: '/Assets/navIcons/coursesNavIcons/IntroductionIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/White/IntroductionIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/logical-thinking-and-flowchart-design.png',
      desc: 'Design flowcharts to boost logical reasoning',
      courseLevel: 'Intermediate',
      cardBgColor: '#EEF7FF',
    },
  ],
  NumberSystem: [
    {
      id: 'code-juniors-courses/introduction-to-number-systems',
      title: 'Introduction to Number Systems',
      img: '/Assets/navIcons/coursesNavIcons/NumberSystemIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/White/NumberSystemIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/introduction-to-number-systems.png',
      desc: 'Explore the foundations of number systems',
      courseLevel: 'Beginner',
      cardBgColor: '#FEF2F4',
    },
    {
      id: 'code-juniors-courses/number-system-conversions',
      title: 'Number System Conversions',
      img: '/Assets/navIcons/coursesNavIcons/NumberSystemIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/White/NumberSystemIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/number-system-conversions.png',
      desc: 'Master conversions between number systems',
      courseLevel: 'Intermediate',
      cardBgColor: '#FFFBDA',
    },
  ],
  Python: [
    {
      id: 'code-juniors-courses/python-beginner',
      title: 'Python Part I',
      img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/White/PythonIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/python-beginner.png',
      desc: 'Start learning Python basics',
      courseLevel: 'Beginner',
      cardBgColor: '#f8edfb',
    },
    {
      id: 'code-juniors-courses/python-intermediate',
      title: 'Python Part II',
      img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/White/PythonIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/python-intermediate.png',
      desc: 'Enhance your Python skills',
      courseLevel: 'Intermediate',
      cardBgColor: '#EEF7FF',
    },
    {
      id: 'code-juniors-courses/python-advanced',
      title: 'Python Part III',
      img: '/Assets/navIcons/coursesNavIcons/PythonIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/White/PythonIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/python-advanced.png',
      desc: 'Master advanced Python techniques',
      courseLevel: 'Advanced',
      cardBgColor: '#FFFBDA',
    },
  ],
  ProblemSolvingBeginners: [
    {
      id: 'code-juniors-courses/number-problems-in-python',
      title: 'Number Problems',
      img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/number-problems.png',
      desc: 'Tackle complex number-related challenges',
      courseLevel: 'Beginner',
      cardBgColor: '#FEF2F4',
    },
    {
      id: 'code-juniors-courses/printing-patterns-in-python',
      title: 'Printing Patterns',
      img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/printing-patterns.png',
      desc: 'Create intricate designs using code',
      courseLevel: 'Beginner',
      cardBgColor: '#F9F3F3',
    },
    {
      id: 'code-juniors-courses/array-problems-in-python',
      title: 'Array Problems',
      img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/array-problems.png',
      desc: 'Master array-based problem-solving techniques',
      courseLevel: 'Beginner',
      cardBgColor: '#EBF4F6',
    },
    {
      id: 'code-juniors-courses/string-problems-in-python',
      title: 'String Problems',
      img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/string-problems.png',
      desc: 'Master advanced string manipulation tasks',
      courseLevel: 'Beginner',
      cardBgColor: '#FFFBDA',
    },
    {
      id: 'code-juniors-courses/bitwise-problems-in-python',
      title: 'Bitwise Problems',
      img: '/Assets/navIcons/coursesNavIcons/ProblemsBeginnerIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/ProblemsBeginnerIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/bitwise-problems.png',
      desc: 'Unlock solutions through bitwise logic',
      courseLevel: 'Beginner',
      cardBgColor: '#EEF7FF',
    },
  ],
  FrontEndDevelopment: [
    {
      id: 'code-juniors-courses/html-juniors',
      title: 'HTML',
      img: '/Assets/navIcons/coursesNavIcons/HTMLIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/HTMLIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/html-juniors.png',
      desc: 'Build your own website',
      courseLevel: 'Beginner',
      cardBgColor: '#EBF4F6',
    },
    {
      id: 'code-juniors-courses/css-juniors',
      title: 'CSS',
      img: '/Assets/navIcons/coursesNavIcons/CSSIcon.svg',
      whiteImg: '/Assets/navIcons/coursesNavIconsWhite/CSSIconWhite.svg',
      cardImg: '/Assets/CodeJuniorsCourses/NewLandingPage/css-juniors.png',
      desc: 'Make your website beautiful with CSS',
      courseLevel: 'Beginner',
      cardBgColor: '#FEF2F4',
    },
  ],
};
